export default __webpack_public_path__ + "images/6a32b72e55d5e3ea7b348a9bd3d462fe-play-icon.svg";